import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    ErrorStatus: false,
    LandingTabs: 'MarketPerformance',
    SelectedCompany: '',
    SelectedIndustry: '',
    SelectedHouse: '',
    IsConsolidate: "false",
    Export: "",
    ExportDetails: {
        export: false,
        size: 0,
    },
    exported: false,
    Innerpage: false,
    TopYear: '10',
    Currencyvalue: 's17',
    CurrencyName: 'Rs',
    RsIn: 1,
    RsInValue: 'Crores',
    NoOfDigit: '2',
    CutoffDB: '',
    Order: 'asc',
    Toggleleftmenu: '',
    Currencyconvert: '1',
    PeersetData: [],
    companyCoCode: '',
    subType: '',
    GetReportAnalysis: '',
    loginType: '',
}


export const CommonLocalSlice = createSlice({
    name: "CommonSlice",
    initialState,
    reducers: ({
        SetErrorStatus: (state, action) => {
            state.ErrorStatus = action.payload
        },
        setLandingTabs: (state, action) => {
            state.LandingTabs = action.payload
        },
        setSelectedCompany: (state, action) => {
            state.SelectedCompany = action.payload
        },
        setSelectedIndustry: (state, action) => {
            state.SelectedIndustry = action.payload
        },
        setSelectedHouse: (state, action) => {
            state.SelectedHouse = action.payload
        },
        setIsConsolidate: (state, action) => {
            state.IsConsolidate = action.payload
        },
        setExport: (state, action) => {
            state.Export = action.payload
        },
        setExported: (state, action) => {
            state.exported = action.payload
        },
        setInnerpage: (state, action) => {
            state.Innerpage = action.payload
        },
        toggleExported: (state) => {
            state.exported = !state.exported;
        },
        setExportDetails: (state, action) => {
            state.ExportDetails = {
                export: action.payload.export,
                size: action.payload.size
            };
        },
        setTopYear: (state, action) => {
            const val = action.payload;
            state.TopYear = (val && Number(val) > 10) ? '10' : (val || '10');
        },
        setCurrency: (state, action) => {
            state.Currencyvalue = action.payload
        },
        setRsIn: (state, action) => {
            state.RsIn = action.payload
        },
        setRsInValuedata: (state, action) => {
            state.RsInValue = action.payload || 'Crores'
        },
        setCurrencyName: (state, action) => {
            state.CurrencyName = action.payload || 'Rs'
        },
        setNoOfDigit: (state, action) => {
            state.NoOfDigit = action.payload
        },
        setCutoffDB: (state, action) => {
            state.CutoffDB = action.payload
        },
        setOrder: (state, action) => {
            state.Order = action.payload
        },
        setToggleleftmenu: (state, action) => {
            state.Toggleleftmenu = action.payload
        },
        setCurrencyconvert: (state, action) => {
            state.Currencyconvert = action.payload
        },
        setPeersetData: (state, action) => {
            state.PeersetData = action.payload
        },
        setcompanyCoCode: (state, action) => {
            state.companyCoCode = action.payload
        },
        setSubType: (state, action) => {
            state.subType = action.payload
        },
        setReportAnalysis: (state, action) => {
            state.GetReportAnalysis = action.payload
        },
        setLoginType: (state, action) => {
            state.loginType = action.payload
        },
    })
})



// "Year": Year,
// "Currency": Currency,
// "RsIn": RsIn,
// "NoOfDigit": NoOfDigit,
// "Order": Order,
// 'RsInValue': RsInValue,
// "CurrencyName": CurrencyName
export const {
    SetErrorStatus,
    setLandingTabs,
    setSelectedCompany,
    setSelectedIndustry,
    setSelectedHouse,
    setIsConsolidate,
    setExport,
    setExported,
    toggleExported,
    setInnerpage,
    setExportDetails,
    setTopYear,
    setCurrency,
    setRsIn,
    setNoOfDigit,
    setToggleleftmenu,
    setCurrencyName,
    setRsInValuedata,
    setOrder,
    setCutoffDB,
    setCurrencyconvert,
    setPeersetData,
    setcompanyCoCode,
    setSubType,
    setReportAnalysis,
    setLoginType
} = CommonLocalSlice.actions
export default CommonLocalSlice.reducer
